const thumb = document.querySelectorAll(".thumb-media");

const switchThumb = index => {
  document.querySelector(".thumb-media-active").classList.remove("thumb-media-active");
  thumb[index].classList.add("thumb-media-active");
};

const mySwiper = new Swiper(".swiper", {
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  speed: 500,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  on: {
    afterInit: swiper => {
      thumb[swiper.realIndex].classList.add("thumb-media-active");
      for (let i = 0; i < thumb.length; i++) {
        thumb[i].onclick = () => {
          swiper.slideTo(i);
        };
      }
    },
    slideChange: swiper => {
      switchThumb(swiper.realIndex);
    }
  }
});

jQuery(".swiper .swiper-slide.swiper-slide-duplicate a")
  .removeAttr("data-lightbox")
  .attr("href", "javascript:void(0)");
jQuery(".swiper .swiper-slide.swiper-slide-duplicate a").on("click", function() {
  jQuery(".swiper .swiper-slide.swiper-slide-duplicate-active a").trigger("click");
});
